__turbopack_context__.v({
  "agebadge": "Home-module__Ho9lYW__agebadge",
  "black": "Home-module__Ho9lYW__black",
  "btn-get-started": "Home-module__Ho9lYW__btn-get-started",
  "btn-watch-video": "Home-module__Ho9lYW__btn-watch-video",
  "circle": "Home-module__Ho9lYW__circle",
  "container": "Home-module__Ho9lYW__container",
  "discovercard": "Home-module__Ho9lYW__discovercard",
  "greybackgroundsection": "Home-module__Ho9lYW__greybackgroundsection",
  "hero": "Home-module__Ho9lYW__hero",
  "heroImg": "Home-module__Ho9lYW__heroImg",
  "mobilefont": "Home-module__Ho9lYW__mobilefont",
  "name": "Home-module__Ho9lYW__name",
  "thumbnails": "Home-module__Ho9lYW__thumbnails",
  "title": "Home-module__Ho9lYW__title",
});
